import React from "react";
import "./CoursePreferenceStyle.css";
import TextField from "../../../components/globalComponents/textFields/TextField";
// import PrimaryButton from '../../../components/globalComponents/buttons/primaryButton/PrimaryButton'
import PrimaryButtonImg from "../../../components/globalComponents/buttons/primaryButtonImg/PrimaryButtonImg";
import {
  lmsSliceData,
  getAllElectiveCourse,
  addStudentBidValues,
  clearState,
} from "../../../reducers/lmsSlice";
import { useDispatch, useSelector } from "react-redux";
import PageLoader from "../../../components/globalComponents/PageLoader/PageLoader";
import { useState, useEffect } from "react";
import ErrorToast from "../../../components/Toast/ErrorToast";

const CoursePreference = () => {
  const dispatch = useDispatch();
  let studentId = localStorage.getItem("studentId");
  let programId = localStorage.getItem("programId");
  const { isFetching, getElectiveCourse, isSuccess } =
    useSelector(lmsSliceData);
  const [courseBidValue, setCourseBidValue] = useState([
    { courseId: "", value: "", studentId: studentId, programId: programId },
  ]);

  //toast states
  const [isShowError, setIsShowError] = useState(false);
  const [errMessage, setErrMessage] = useState("");

  useEffect(() => {
    dispatch(getAllElectiveCourse());
  }, []);

  let newArrObj = Object.values(courseBidValue);
  let penPoints = newArrObj
    ?.map((res) => parseInt(res.value ? res.value : 0))
    .reduce((partialSum, a) => partialSum + a, 0);
  console.log(100 - penPoints, "in1123", penPoints);
  const handleChange = (id, index) => (e) => {
    let { name, value } = e.target;

    console.log(value, "out");
    console.log(100 - penPoints, "in", penPoints);
    //   if(value>100-penPoints){
    //     console.log(100-penPoints-1,"if");
    //   }else{ console.log(value,"else");}
    setCourseBidValue((values) => ({
      ...values,
      [index]: {
        value: value,
        courseId: id,
        studentId: studentId,
        programId: programId,
      },
    }));
  };

  // useEffect(() => {
  //   setCourseBidValue(
  //     getElectiveCourse?.length > 0 &&
  //       getElectiveCourse?.map((res) => ({
  //         courseId: res.id,
  //         value: res.StudentBids?.length > 0 ? res.StudentBids[0].bidPoint : "",
  //         studentId: studentId,
  //         programId: programId,
  //       }))
  //   );
  // }, [getElectiveCourse]);

  const handleSubmit = () => {
    let arrObj = Object.values(courseBidValue);
    let newArrObj=arrObj?.filter(res=> res?.value !== "")
    if (penPoints > 100) {
      setIsShowError(true);
      setErrMessage("Point Should be Equal to 100");
      return;
    } else if (penPoints < 100) {
      setIsShowError(true);
      setErrMessage("Point Should be Equal to 100");
      return;
    } else {
      dispatch(addStudentBidValues(newArrObj));
    }
  };

  useEffect(() => {
    if (isSuccess) {
      dispatch(getAllElectiveCourse());
      dispatch(clearState());
      setCourseBidValue([]);
    }
    // eslint-disable-next-line
  }, [isSuccess]);

  let totalNoCourses = getElectiveCourse?.length;

  return (
    <>
      {isFetching && <PageLoader />}
      <ErrorToast
        show={isShowError}
        setShow={() => setIsShowError(false)}
        message={errMessage}
      />
      <div className="pageHeader">
        <p className="componentHeading"></p>
        <div className="pageTogglers">
          <div className="pageToggler active">
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9.99999 18.6667C9.83332 18.6667 9.74999 18.6667 9.58332 18.5834C9.33332 18.5 9.16666 18.3334 8.99999 18L7.74999 16.4167C7.49999 16.0834 7.41666 15.9167 7.33332 15.8334C7.24999 15.75 7.08332 15.6667 6.91666 15.5834C6.83332 15.5834 6.58332 15.5834 6.24999 15.5834C4.99999 15.5834 4.41666 15.5834 3.83332 15.3334C3.08332 15 2.49999 14.4167 2.16666 13.6667C1.91666 13.0834 1.91666 12.5 1.91666 11.25V6.50004C1.91666 5.00004 1.91666 4.25004 2.24999 3.58337C2.49999 3.00004 2.99999 2.50004 3.58332 2.25004C4.24999 1.83337 4.99999 1.83337 6.49999 1.83337H13.5C15 1.83337 15.75 1.83337 16.4167 2.16671C17 2.50004 17.5 3.00004 17.75 3.58337C18.0833 4.25004 18.0833 5.00004 18.0833 6.50004V11.25C18.0833 12.5 18.0833 13.0834 17.8333 13.6667C17.5 14.4167 16.9167 15 16.1667 15.3334C15.5833 15.5834 15 15.5834 13.75 15.5834C13.4167 15.5834 13.25 15.5834 13.0833 15.5834C12.9167 15.5834 12.75 15.6667 12.6667 15.8334C12.5833 15.9167 12.5 16.0834 12.25 16.3334L11 18C10.75 18.3334 10.5833 18.5 10.3333 18.5834C10.25 18.6667 10.1667 18.6667 9.99999 18.6667ZM6.49999 3.16671C5.16666 3.16671 4.58332 3.16671 4.16666 3.33337C3.83332 3.50004 3.49999 3.83337 3.33332 4.16671C3.16666 4.58337 3.16666 5.16671 3.16666 6.50004V11.25C3.16666 12.3334 3.16666 12.8334 3.33332 13.25C3.49999 13.75 3.91666 14.0834 4.33332 14.25C4.66666 14.4167 5.24999 14.4167 6.33332 14.4167C6.74999 14.4167 6.99999 14.4167 7.24999 14.5C7.58332 14.5834 7.91666 14.75 8.16666 15C8.33332 15.1667 8.49999 15.3334 8.74999 15.6667L9.99999 17.3334C9.99999 17.3334 9.99999 17.3334 9.99999 17.4167C9.99999 17.4167 9.99999 17.4167 9.99999 17.3334L11.25 15.75C11.5 15.4167 11.6667 15.1667 11.8333 15C12.0833 14.75 12.4167 14.5834 12.75 14.5C13 14.4167 13.25 14.4167 13.6667 14.4167C14.75 14.4167 15.25 14.4167 15.6667 14.25C16.0833 14.0834 16.5 13.6667 16.6667 13.25C16.8333 12.9167 16.8333 12.3334 16.8333 11.25V6.50004C16.8333 5.16671 16.8333 4.58337 16.6667 4.16671C16.5 3.83337 16.1667 3.50004 15.8333 3.33337C15.4167 3.16671 14.75 3.16671 13.5 3.16671H6.49999Z"
                fill="#0061BF"
              />
              <path
                d="M10 12.4167C9.83333 12.4167 9.75 12.4167 9.58333 12.3334C9.25 12.25 9.08333 12.0834 8.75 11.75C7.66666 10.8334 6.91666 10.0834 6.58333 9.66671C5.75 8.58337 5.91666 7.00004 7 6.08337C7.83333 5.41671 9.08333 5.41671 10 6.08337C10.9167 5.41671 12.0833 5.41671 13 6.16671C14.0833 7.08337 14.25 8.58337 13.4167 9.75004C13 10.25 12 11.1667 11.25 11.8334C10.9167 12.0834 10.75 12.3334 10.4167 12.4167C10.25 12.4167 10.1667 12.4167 10 12.4167ZM8.5 6.91671C8.25 6.91671 8 7.00004 7.75 7.16671C7.25 7.58337 7.16666 8.41671 7.58333 8.91671C7.83333 9.33337 8.58333 10 9.58333 10.8334C9.75 11 9.91666 11.1667 10 11.1667H10.0833C10.1667 11.1667 10.3333 11 10.5 10.8334C11.5 9.91671 12.1667 9.25004 12.5 8.91671C12.9167 8.33337 12.8333 7.58337 12.3333 7.08337C11.5833 6.66671 10.8333 6.91671 10.5 7.33337C10.3333 7.50004 10.1667 7.58337 10 7.58337C9.83333 7.58337 9.66666 7.50004 9.5 7.33337C9.25 7.08337 8.91666 6.91671 8.5 6.91671Z"
                fill="#0061BF"
              />
            </svg>
            Course Registration
          </div>
        </div>
        <div></div>
      </div>
      <div className="coursePreferenceOuter">
        <div className="student-profile-outer bidding-box-outer">
          <div className="student-profile-right">
            <div className="policy-box">
              <div className="policy-header">
                <img src="../assets/icons/question.svg" alt="" />
                <p>Distributing points for electives</p>
              </div>
              <ul className="dot-list">
                <li className="dot-list-item">
                  You will recieve 10 points which you can distribute among the
                  electives.
                </li>
                <li className="dot-list-item">
                  Courses with higher points will have a higher preference
                </li>
                <li className="dot-list-item">
                  The total of all points must add up to 10 cannot be less than
                  10
                </li>
                <li className="dot-list-item">
                  Once you submit your preference it cannot be changed
                </li>
              </ul>
            </div>
          </div>
          <div className="student-profile-left">
            <div className="student-details">
              <p className="item">Total Points</p>
              <p className="count primary-text">100</p>
            </div>
          </div>
          <div className="student-profile-left">
            <div className="student-details">
              <p className="item">Pending Points</p>
              <p className="count primary-text">{100 - penPoints}</p>
            </div>
          </div>
          <div className="student-profile-left">
            <div className="student-details">
              <p className="item">Total no. of courses</p>
              <p className="count successText">
                {newArrObj?.length}/{totalNoCourses}
              </p>
              <p className="item2">Minimum 2 Elective Course</p>
            </div>
          </div>
        </div>
        <div className="filterBar">
          <div className="searchBox">
            <img src="../assets/icons/search-sm.svg" alt="" />
            <input
              type="text"
              className="searchInput"
              placeholder="Search ..."
            />
          </div>
          <button
            className="fiterBtn"
            //  onClick={() => setOpenFilters(!openFilters)}
          >
            {" "}
            <img src="../assets/icons/filter-lines.svg" alt="" /> Filters
          </button>
        </div>
        <div className="biddingContainer">
          <div className="biddingTableOuter">
            <table className="biddingTable" cellSpacing={0} cellPadding={0}>
              <thead>
                <tr>
                  <th>Selected elective courses</th>
                  {/* <th>Faculty</th> */}
                  <th>Course Code</th>
                  {/* <th>Available Seats</th> */}
                  <th style={{ width: "20%" }}>Points</th>
                </tr>
              </thead>
              <tbody>
                {getElectiveCourse?.length > 0 &&
                  getElectiveCourse?.map((res, i) => (
                    <tr>
                      <td>{res.courseName}</td>
                      {/* <td>Narendra Yadav</td> */}
                      <td>{res.courseCode}</td>
                      {/* <td>09</td> */}
                      {/* <td style={{ width: '20%' }}>
                                            <TextField placeholder={'Enter Points'} />
                                        </td> */}
                      {res.StudentBids?.length > 0 ? (
                        <td style={{ width: "20%" }}>
                          <input
                            type="number"
                            className="formInput"
                            key={i}
                            name="courseBidValue"
                            value={courseBidValue[i]?.value}
                            onChange={(e) => handleChange(res.id, i)(e)}
                            disabled
                            placeholder={res.StudentBids?.[0]?.bidPoint}
                          />
                        </td>
                      ) : (
                        <td style={{ width: "20%" }}>
                          <input
                            type="number"
                            className="formInput"
                            key={i}
                            name="courseBidValue"
                            value={courseBidValue[i]?.value}
                            onChange={(e) => handleChange(res.id, i)(e)}
                            placeholder={"Enter Points"}
                          />
                        </td>
                      )}
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
          <div className="fixedRowBottom">
            <p>Total is less than 100</p>
            <PrimaryButtonImg
              img={"/assets/icons/whiteArrow.svg"}
              children={"Submit"}
              classname={"successBtn"}
              onClick={handleSubmit}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default CoursePreference;
